export default {"src":"/_next/static/media/chevronTop.13576a65.svg","height":8,"width":12};